import { gql } from '@apollo/client';

export const PM_ONBOARDING_FLOW_STEP_FIELDS = gql`
  fragment PmOnboardingFlowStepFields on PmOnboardingFlowStep {
    stepKey
    position
    label
    required
  }
`;

export const PM_ONBOARDING_FLOW_FIELDS = gql`
  ${PM_ONBOARDING_FLOW_STEP_FIELDS}
  fragment PmOnboardingFlowFields on PmOnboardingFlow {
    id
    version
    name
    description
    isActive
    totalSteps
    steps {
      ...PmOnboardingFlowStepFields
    }
  }
`;

export const PM_ONBOARDING_STEP_COMPLETION_FIELDS = gql`
  fragment PmOnboardingStepCompletionFields on PmOnboardingStepCompletion {
    stepKey
    completedAt
  }
`;

export const PM_ONBOARDING_SESSION_FIELDS = gql`
  ${PM_ONBOARDING_FLOW_FIELDS}
  ${PM_ONBOARDING_STEP_COMPLETION_FIELDS}
  fragment PmOnboardingSessionFields on PmOnboardingSession {
    id
    accountId
    userId
    pmsType
    currentStepKey
    status
    reviewReason
    publishedAt
    startedAt
    completedAt
    lastActivityAt
    currentStepIndex
    totalSteps
    completedStepKeys
    canAdvance
    flow {
      ...PmOnboardingFlowFields
    }
    stepCompletions {
      ...PmOnboardingStepCompletionFields
    }
    account {
      id
      isUsBased
      countryOrRegionLongName
    }
  }
`;
